export const getCfdModuleStub = () => ({
    product: '',
    current_list: {},
    account_type: {},
    jurisdiction_selected_shortcode: '',
    toggleMT5TradeModal: () => undefined,
    setMT5TradeAccount: () => undefined,
    createCFDAccount: () => Promise.resolve(),
    enableCFDPasswordModal: () => undefined,
    setCurrentAccount: () => undefined,
});
